import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ajaxUser from "../util/remote/ajaxUser";
import Loader from "../Components/Common/Loader";
import toast, { Toaster } from "react-hot-toast";
const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  // JWT decoder
  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const pass = btoa(password); // base64 encode
    const data = { username, password: pass };
    const server_response = await ajaxUser.loginUser(data);
    if (server_response.status === "OK") {
      const decoded_token = parseJwt(server_response.details);
      if (decoded_token) {
        const stationId = decoded_token.data?.station_id ?? "";
        const isCompanyUser = decoded_token.data?.is_company_user ?? "";
        const role_id = decoded_token.data?.role_id ?? "";
        const companyId = decoded_token.data?.company_id ?? "";
        const token = server_response.details;
        const loginTime = Date.now().toString();
        // Save to localStorage
        localStorage.setItem("FuelFy@daisy", token);
        localStorage.setItem("FuelFy@station_id", stationId);
        localStorage.setItem("FuelFy@is_company_user", isCompanyUser);
        localStorage.setItem("FuelFy@company_id", companyId);
        localStorage.setItem("FuelFy@rollly", role_id);
        localStorage.setItem("loginTime", loginTime);
        toast.success(server_response.message);
        navigate("/"); // redirect after login
        window.location.reload();
      } else {
        toast.error("Failed to decode token");
      }
    } else {
      toast.error(server_response.message);
    }
    setLoading(false);
  };
  return (
    <div
      className="login-container"
      style={{
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${process.env.PUBLIC_URL}/login_bg_2.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <Toaster />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.55)",
          backdropFilter: "blur(2px)",
        }}
      ></div>
      <div
        className="login-card"
        style={{
          width: "380px",
          padding: "35px",
          borderRadius: "18px",
          background: "rgba(255,255,255,0.12)",
          backdropFilter: "blur(14px)",
          boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
          color: "#fff",
          zIndex: 2,
        }}
      >
        <div className="text-center mb-3">
          <img
            src={process.env.PUBLIC_URL + "/assets/img/brand/logo.png"}
            alt="logo"
            style={{ height: "60px" }}
          />
        </div>
        <h3 className="text-center mb-3" style={{ fontWeight: 600 }}>
          Login In
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group text-left mb-3">
            <label style={{ fontWeight: 500 }}>Username</label>
            <input
              className="form-control"
              placeholder="Enter username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                background: "rgba(255,255,255,0.85)",
                border: "none",
                borderRadius: "10px",
              }}
            />
          </div>
          <div
            className="form-group text-left mb-3"
            style={{ position: "relative" }}
          >
            <label style={{ fontWeight: 500 }}>Password</label>
            <input
              className="form-control"
              placeholder="Enter your password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                background: "rgba(255,255,255,0.85)",
                border: "none",
                borderRadius: "10px",
                paddingRight: "40px",
              }}
            />
            <i
              className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "12px",
                top: "30px",
                cursor: "pointer",
                fontSize: "18px",
                color: "#333",
              }}
            ></i>
          </div>
          <button
            className="btn btn-primary btn-block"
            style={{
              width: "100%",
              borderRadius: "10px",
              padding: "10px",
              fontWeight: 600,
              backgroundColor: "#3167eb",
              border: "none",
              cursor: "pointer",
            }}
          >
            {loading ? "Signing IN ....." : "SIGN IN"}
          </button>
        </form>
        <div className="mt-4 text-center">
          <p className="mb-1">
            <a
              href="#"
              style={{ color: "#cfd4ff", textDecoration: "underline" }}
            >
              Forgot password?
            </a>
          </p>
          {/* <p className="mb-0">
            Don't have an account?
            <a href="signup.html" style={{ color: "#fff", fontWeight: "bold" }}>
              Create an Account
            </a>
          </p> */}
        </div>
      </div>
    </div>
  );
};
export default LoginPage;
